// Env flags are strings; treat only an explicit opt-in as on.
const isEnabled = (raw: string | undefined): boolean =>
  raw?.trim().toLowerCase() === 'true' || raw?.trim() === '1'

// /sports chrome switches, both default OFF so the iframe gets the viewport.
export const SPORTS_SHOW_HEADER = isEnabled(
  import.meta.env.VITE_SPORTS_SHOW_HEADER,
)

export const SPORTS_SHOW_BOTTOM_NAV = isEnabled(
  import.meta.env.VITE_SPORTS_SHOW_BOTTOM_NAV,
)

// Both the header and the bottom nav are 60px tall.
export const CHROME_BAR_HEIGHT = 60

export const SPORTS_PATH = '/sports'

const rawKeepAlive = Number(import.meta.env.VITE_SPORTS_KEEPALIVE_SECONDS)

// How long the lobby keeps running after the player navigates away. Within this
// window the iframe is only hidden, so coming back is instant and no loading
// splash shows; past it the lobby unmounts and the next visit reloads it.
// 6 minutes: long enough to cover a detour into the casino, and still short of
// the 600s guest ticket so a reload after it rarely holds a dead ticket.
const DEFAULT_KEEP_ALIVE_SECONDS = 6 * 60

// Shortest gap between two reloads triggered by the lobby losing its session.
export const SPORTS_SESSION_RELOAD_COOLDOWN_MS = 10 * 1000

export const SPORTS_KEEP_ALIVE_MS =
  (Number.isFinite(rawKeepAlive) && rawKeepAlive > 0
    ? rawKeepAlive
    : DEFAULT_KEEP_ALIVE_SECONDS) * 1000
